import { useVendorConfig } from './VendorContext';
import { FeatureKey } from './vendorTypes';

export const useIsVendorFeatureSupported = (feature: FeatureKey) => {
    const { features } = useVendorConfig();

    return features?.[feature] !== false;
};
